import React from "react";

const SecurePolicy = ({ common_icons }) => {
  return (
    <>
      <p className="secured-data">
        <img src={common_icons["secure_lock"]} width={10} height={10} /> Your
        information is secure with us
      </p>
      <p className="secured-data" style={{ fontSize: "10px" }}>
        “100% private. Used only to customize your keto plan for real results.”
      </p>
    </>
  );
};

export default React.memo(SecurePolicy);
